import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_moveTo } from './taskMoveTo'

export const register = () => registerJob('move-to', runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, 'move-to')

  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    // Go to
    let task = createTask_moveTo(job.i, job.j, job.isInShip, false)
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
